import { Component, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as moment from 'moment';
import { LocalStorageNativeService } from 'src/services/NativeLocalStorage.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-custom-datetime-picker',
  templateUrl: './custom-datetime-picker.component.html',
  styleUrls: ['./custom-datetime-picker.component.scss'],
})
export class CustomDatetimePickerComponent implements OnDestroy {
  public maxDate = (Number(new Date().getFullYear())+1) + '-12-31';
  public customDate: any;
  public currentTime: any;

  public defaultDate: any;
  public defaultTime: any;

  public localeString: string;
  public customPres: string = 'date-time';
  public paramPres: string;
  public currentDate: string;

  public modalType = 1;
  minInsterval: number[];

  constructor(private modalCtrl: ModalController, public storageService: LocalStorageNativeService) {}

  ngOnInit() {
    const minT = 0,
      maxT = 55,
      interval = 5;

    const length = (maxT - minT) / interval + 1;
    this.minInsterval = Array.from({ length }, (_, i) => minT + i * interval);
    if(this.customDate){
      this.defaultDate = this.customDate;
      const splitTime = this.customDate.toString().split('T');
      this.defaultTime = splitTime[1].slice(0, 5);//this.customDate;
    }
    else{
      this.currentDate = moment().add(1, 'days').format('YYYY-MM-DD')+ 'T01:01:01-01:00';
      //this.currentDate = moment().add(1, 'days').format("YYYY-MM-DD");
      this.defaultDate = this.currentDate;
      console.log('this.currentDate: ', this.currentDate);
      const splitTime = this.currentDate.toString().split('T');
      this.defaultTime = splitTime[1].slice(0, 5);
    }
   
    this.getLanguageApp();
    if(this.paramPres){
      this.customPres = this.paramPres;
    }
  }

  async getLanguageApp(){
    const language = await this.storageService.getItem('selectedLanguage');
    if (language || language !== null) {
        this.localeString = (language === 'es') ? 'es-MX' : 'en-US';
    }
    else{
      this.localeString = 'en-US';
    }
  }

  ngOnDestroy() {}

  async close() {
    this.modalCtrl.dismiss();
  }

  selectDate() {
    if(this.customPres === 'date'){
    this.modalCtrl.dismiss({
      cDate: this.defaultDate
    });
    }
    else{
      const splitDate = this.defaultDate.toString().split('T');
      //const splitTime = this.defaultTime.toString().split('T');
      //console.log(splitDate[0]+'T'+this.defaultTime+':00-05:00');
      this.modalCtrl.dismiss({
        cDate: splitDate[0]+'T'+this.defaultTime+':00-05:00'
      });
    }
  }

}
